import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import {
  getCurrentPracticePatient,
  getCurrentPracticePatientForm,
} from "../../core/store/currentFormSlice";
import { useMainStore } from "../../core/store/mainStore";
import { LoadingScreen } from "../navigation/LoadingScreen";
import { useGetTreatmentContracts } from "../practiceForms/utils/useGetTreatmentContracts";
import { usePracticeFormConnect } from "../practiceForms/utils/usePracticeFormConnect";
import { useSkipSubmittedForms } from "../practiceForms/utils/useSkipSubmittedForms";
import { usePracticePatientConnect } from "./utils/usePracticePatientConnect";

export const FormLayout = () => {
  const runStartDecided = useSkipSubmittedForms();
  usePracticeFormConnect();
  usePracticePatientConnect();
  useGetTreatmentContracts();

  // The form pages do not scroll, so a thumb sliding down on "Weiter" would pull to refresh.
  useEffect(() => {
    const root = document.documentElement;
    const previous = root.style.overscrollBehaviorY;
    root.style.overscrollBehaviorY = "none";
    return () => {
      root.style.overscrollBehaviorY = previous;
    };
  }, []);

  const currentPracticePatientForm = useMainStore(
    getCurrentPracticePatientForm,
  );
  const currentPracticePatient = useMainStore(getCurrentPracticePatient);
  if (!runStartDecided || !currentPracticePatientForm || !currentPracticePatient) {
    return <LoadingScreen />;
  }

  return <Outlet />;
};
